// Mobile-native helpers: tap-to-call, tap-to-WhatsApp, geolocation
// Include anche normalizzazione numeri telefonici italiani.

/** Pulisce e normalizza un numero italiano (anche con prefisso). */
export function normalizePhone(p) {
  if (!p) return "";
  let s = String(p).replace(/[^\d+]/g, "");
  if (s.startsWith("00")) s = "+" + s.slice(2);
  if (s.startsWith("39") && !s.startsWith("+")) s = "+" + s;
  if (!s.startsWith("+") && s.length >= 9) s = "+39" + s; // default IT
  return s;
}

/** href per tap-to-call. */
export function telLink(p) {
  const n = normalizePhone(p);
  return n ? `tel:${n}` : "";
}

/** href per tap-to-WhatsApp con eventuale messaggio precompilato. */
export function waLink(p, message) {
  const n = normalizePhone(p).replace(/^\+/, "");
  if (!n) return "";
  const q = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${n}${q}`;
}

/** Geolocalizzazione. Ritorna {lat, lon, accuracy} oppure null. */
export function getGeo(timeoutMs = 8000) {
  return new Promise((resolve) => {
    if (!("geolocation" in navigator)) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({
        lat: pos.coords.latitude,
        lon: pos.coords.longitude,
        accuracy: pos.coords.accuracy,
      }),
      () => resolve(null),
      { timeout: timeoutMs, maximumAge: 60000, enableHighAccuracy: false },
    );
  });
}

/** Genera URL Google Maps per navigazione verso un indirizzo. */
export function mapsLink(address) {
  if (!address) return "";
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}

/** href per SMS con testo precompilato (iOS usa `&body=`, Android `?body=`). */
export function smsLink(p, message) {
  const n = normalizePhone(p);
  if (!n) return "";
  if (!message) return `sms:${n}`;
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent || "");
  const sep = isIOS ? "&" : "?";
  return `sms:${n}${sep}body=${encodeURIComponent(message)}`;
}

/** Vibrazione tattile breve (feedback). */
export function buzz(ms = 12) {
  try { navigator.vibrate?.(ms); } catch {}
}
